import {
  all,
  call,
  delay,
  put,
  select,
  takeEvery,
} from "redux-saga/effects";
import {
  COMMON_BENEFITS_START,
  COMMON_BENEFITS_FAILED,
  BENEFITS_LOOKUP_START,
  commonBenefitsFailed,
  noCommonBenefits,
  commonBenefitsSuccess,
  updatePartnerDetailsExperience,
  updateSessionId,
  updatePpuFlag,
  updateLoggedInFlag,
  updateServiceDetails,
  updateServiceTransition,
  updateDuplicateRescueIsActive,
  updatePromoCode,
  updatePartnerMemberId,
  updateUsageId,
  updateBusinessName,
  updateRentalDetail,
  refreshReducersToInitial,
  updateStackedInfo,
  updateMemberId,
  updatePostFix,
  updateUserDetails
} from '../action';
import {
  getCommonBenefits,
  getPartnerDetails,
  getServiceRequestPayload,
  getServiceTransition,
  getUserDetails,
} from '../selector';
import {
  createMemberSessionOpenApi,
  fetchCommonBenefitsForUser,
  fetchBenefits,
  searchRescue,
  sendJacadaRequest,
  fraudMonitor,
  fetchPPUBenefits,
} from "../api";
import CONSTANTS, {
  ACTIVE_MEMBERSHIP_STATUSES,
  AMC,
  BENEFITS_USED_UP,
  C74,
  CONTRACT_CANCELLED,
  CONTRACT_EXPIRED,
  CONTRACT_NOT_ACTIVE_YET,
  DISPATCH_GUARANTEE,
  INACTIVE,
  JJ_AND_AMC,
  LAST_NAME_AUTHENTICATION_CHECK_LOOKUP_TYPES,
  LAST_NAME_AUTHENTICATION_CHECK_PARTNERS,
  MATCH_FAILURE,
  MEMBER_NOT_FOUND_STATUS,
  MEMBER_NOT_FOUND_VAS,
  MUTLIPLE_MEMBERS_FOUND,
  MULTIPLE_MEMBERS_RETURNED,
  PEP,
  PPU_GHR_APP_ID,
  NOT_COVERED_REASONS,
  REIMBURSEMENT,
  WAIT_PERIOD_STATUS,
  VZW,
  MEMBER_NUMBER_VIN,
  LAST_NAME_STATE_ZIP,
  GHR_HOLIDAY_PROMO_CODE,
} from "../app-consts/appConstants";
import {
  isCreatedNoContentStatus,
  is4xxClientError,
  is5xxServerError,
} from "../utils/apis";
import { ErrorSource } from "@datadog/browser-core";
import { datadogRum } from "@datadog/browser-rum";
import trimmedLengthIsTen from "../utils/phoneLength";
import {
  MEMBER_NOT_FOUND,
  UNABLE_TO_PROCESS_REQUEST,
} from "../app-consts/errorMessageConstants";
import { experimentalMonitor } from '../utils/experimentalMonitorUtil';
import {isEmpty} from "lodash";
import {generatePathWithSearchParams} from "../utilities/RedirectUtils";
import { enhancedAuthLookupOverrides } from "../features/EnhancedAuth/helper/enhancedAuthBenefitLookUpHelper";
import { getOmniStreamlinedFlag, getPepPromotionFlag } from "../features/FeatureFlags";
import { getMemberNotFoundMessage, emitBenefitsJourneyEvent } from "./helpers";

const PPU_POLICY_ELIGIBILITY_ACTION = "PPU Policy Eligibility";
const TOLL_FREE_NUMBER_PARTNERS = ["FAK", "FCA", "FUM", "VAV", "V15"];

function logPolicyDrivenPpuEligibility(reason, details = {}) {
  const { callId, ...restDetails } = details;
  datadogRum.addAction(PPU_POLICY_ELIGIBILITY_ACTION, {
    ppuEligibilityReason: reason,
    callId,
    ...restDetails,
  });
}

function logAndReturn500Failure(sessionId) {
  datadogRum.addError(new Error(`Benefits API returned status 500 for session ID ${sessionId}.`), {
    source: ErrorSource.NETWORK,
  });
  return put({ type: COMMON_BENEFITS_FAILED });
}

function logAndReturnMaxAttemptsFailure(sessionId, isAllstatePartner = false) {
  datadogRum.addError(new Error(`Benefits API hit max attempts for session ID ${sessionId}.`), {
    source: ErrorSource.CUSTOM,
  });
  const memberNotFoundMessage = getMemberNotFoundMessage(isAllstatePartner);
  return put(
    noCommonBenefits({
      message: memberNotFoundMessage,
      response: {},
    })
  );
}

function logAndCheckAmcMilesFlow({ amcCoverageAmount, coveredMiles }) {
  if (
    amcCoverageAmount &&
    parseInt(amcCoverageAmount) === 9999990 &&
    coveredMiles &&
    coveredMiles !== "999999" &&
    parseInt(coveredMiles) > 0
  ) {
    localStorage.setItem("amcMilesFlow", "true");
    datadogRum.addRumGlobalContext("usr", {
      amcMilesFlow: "true",
    });
  } else {
    localStorage.removeItem("amcMilesFlow");
  }
}

function logAndReturnOutOfClaims(benefits, omniStreamlined) {
  let newErrorMessage = !!omniStreamlined && NOT_COVERED_REASONS.find(pair => pair.id === benefits.status?.toUpperCase())
  let errorReason = newErrorMessage?.reason;
  if (
    !!newErrorMessage &&
    newErrorMessage.reason !== CONSTANTS.OUT_OF_CLAIMS_MESSAGE
  ) {
    datadogRum.addAction(
      `Customer has ${errorReason} for the partner: ${benefits.partnerCode}`
    );
  } else {
    datadogRum.addAction("Benefits Used Up");
    datadogRum.addRumGlobalContext("usr", {
      claims: "Out of claims",
    });
    errorReason = CONSTANTS.OUT_OF_CLAIMS_MESSAGE;
  }
  return put(noCommonBenefits({ message: errorReason, response: benefits }));
}

function logAndReturnSuccess({
  sessionId: session,
  partnerCode,
  appId,
  responseBody,
  type,
  phone,
}) {
  datadogRum.addAction("Benefits Available");
  datadogRum.addRumGlobalContext("usr", {
    session,
    memberId: responseBody.memberId,
    partnerCode,
    appId,
    conversationId: localStorage.getItem("conversationId") || "unavailable",
    jobId: localStorage.getItem("jobId") || "unavailable",
    ani: phone || "unavailable",
  });
  localStorage.setItem("sessionType", type);
  return put(commonBenefitsSuccess(responseBody));
}

function generateVehicleEventDataObj(equipmentClassId) {
  if (equipmentClassId === "Light") {
    return {
      name: "equpmnt_clss_id",
      value: "1",
    };
  } else if (equipmentClassId === "Medium") {
    return {
      name: "equpmnt_clss_id",
      value: "2",
    };
  } else if (equipmentClassId === "Heavy") {
    return {
      name: "equpmnt_clss_id",
      value: "3",
    };
  } else {
    return {
      name: "equpmnt_clss_id",
      value: equipmentClassId,
    };
  }
}

function generateJacadaEventsObj({
  memberId,
  partnerCode,
  promoCode,
  sessionId,
  phone,
  authenticated,
  equpmnt_clss_id,
}) {
  let eventsData = [];
  eventsData.push(
    {
      name: "mbr_id",
      value: authenticated === "Y" ? memberId : "",
    },
    {
      name: "partnr_cd",
      value: partnerCode,
    },
    {
      name: "disblmnt_prmotn_cd",
      value: promoCode,
    },
    {
      name: "sessionId",
      value: sessionId,
    },
    {
      name: "original_ani_nbr",
      value: phone,
    },
    {
      name: "job_id",
      value: localStorage.getItem("jobId"),
    }
  );

  if (authenticated === "Y") {
    eventsData.push({
      name: "authenticated",
      value: authenticated,
    });
  }

  if (equpmnt_clss_id) {
    eventsData.push(generateVehicleEventDataObj(equpmnt_clss_id));
  }
  return eventsData;
}

function* logJacadaEvent({
  memberId,
  partnerCode,
  promoCode,
  sessionId,
  phone,
  authenticated,
  equpmnt_clss_id,
}) {
  try {
    const conversationId =
      localStorage.getItem("conversationId") || "unavailable";
    const jacadaResponse = yield call(sendJacadaRequest, {
      externalSystemId: conversationId,
      events: generateJacadaEventsObj({
        memberId: authenticated === "Y" ? memberId : "",
        partnerCode,
        promoCode,
        sessionId,
        phone,
        authenticated,
        equpmnt_clss_id,
      }),
    });
    if (jacadaResponse.status === 200) {
      datadogRum.addAction(`${partnerCode}-jacada-authentication`, {
        authenticated: authenticated,
      });
    } else {
      const error = new Error(
        `Jacada returned ${
          jacadaResponse.status
        } status for Conversation ID: ${conversationId}, Request: ${JSON.stringify(
          jacadaResponse
        )}.`
      );
      datadogRum.addError(error, { source: ErrorSource.CUSTOM });
    }
  } catch (e) {
    datadogRum.addError(
      new Error(`Jacada event failure ${e}`),
      {source: ErrorSource.CUSTOM}
    );
  }
}

export function* commonBenefits(action) {
  const commonBenefits = yield select(getCommonBenefits);
  const partnerDetails = yield select(getPartnerDetails);
  const serviceRequestPayload = yield select(getServiceRequestPayload);

  let postFix = serviceRequestPayload.postFix;
  let memberId = action.payload.memberId || commonBenefits.memberId;
  let rentalAgreementNumber = action.payload.rentalAgreementNumber;
  let vin = action.payload.vin || commonBenefits.vin;
  let mileage = action.payload.mileage;
  let existingSessionId = action.payload.sessionId;
  let phoneLookup = action.payload.phoneLookup;
  let lastName = action.payload.lastName ? action.payload.lastName : null;
  if (
    phoneLookup &&
    trimmedLengthIsTen(serviceRequestPayload.serviceRequest.contactNumber)
  ) {
    memberId = serviceRequestPayload.serviceRequest.contactNumber;
  }
  const lookupType = action.payload.lookupType;
  let { partnerCode, promoCode, route, appId, experience } = partnerDetails;
  const memberNotFoundMessage = getMemberNotFoundMessage(!!experience?.allstatePartner);
  const type = "wle-client";

  const details = action.payload.details;
  const arsToken = action.payload.arsToken;
  const createSessionRequest = action.payload.formdata
    ? action.payload.formdata
    : null;
  let phone = serviceRequestPayload.serviceRequest.contactNumber;

  let authenticated = "N";
  let retryBenefits = true;
  let retryBenefitsCounter = 0;
  let sessionId = "";
  let equpmnt_clss_id = "";
  let sessionResponse = "";

  let completeResponse;

  try {
    // NOTE: using redux-effect's call function will not accept a plain object hence the options construction here <?!>
    const options = {
      memberId,
      partnerCode,
      appId,
      type,
      createSessionRequest,
      phoneLookup,
      details,
      vin,
      mileage,
      arsToken,
      lastName,
      rentalAgreementNumber,
    };
    if (!existingSessionId) {
      if (memberId) {
        const searchRescueResponse = yield call(
          searchRescue,
          partnerCode,
          appId,
          lookupType,
          memberId,
          postFix
        );
        if (searchRescueResponse.status === 200) {
          const { usageId = "", callId = "", duplicateRescueIronDoor = {} } =
            searchRescueResponse.data;
          experimentalMonitor(duplicateRescueIronDoor)(
            "Denominator",
            { usageId },
            "duplicateRescueIronDoor"
          );
          yield put(
            updateDuplicateRescueIsActive({
              usageId,
              callId,
              duplicateRescueIronDoor,
            })
          );
          return;
        }
      }
      sessionResponse = yield call(createMemberSessionOpenApi, route, options);
      if (sessionResponse.status === 200) {
        sessionId = sessionResponse.data.id;
        localStorage.setItem("benefitSession", sessionId);
        if (sessionId) {
          yield put(updateSessionId(sessionId));
        }
      } else if (
        sessionResponse.status === 400 &&
        sessionResponse.data?.message?.toLowerCase() ===
          "invalid oauth token for supplied client id."
      ) {
        yield put(
          commonBenefitsFailed({
            message: CONSTANTS.INVALID_OAUTH_TOKEN,
          })
        );
        return;
      } else if (sessionResponse.status === 400) {
        if (
          LAST_NAME_AUTHENTICATION_CHECK_PARTNERS.includes(partnerCode) &&
          LAST_NAME_AUTHENTICATION_CHECK_LOOKUP_TYPES.includes(lookupType)
        ) {
          datadogRum.addError(
            new Error(`Session API returned 400 response for ${sessionResponse.data?.message}, memberId: ${memberId}, lastName: ${lastName}, sessionId: ${sessionId}`), {options}
          );
        } else {
          datadogRum.addError(
            new Error(
              `Session API returned 400 response for AppID: ${appId} / Partner Code: ${partnerCode} / LookupType: ${lookupType}`
            ),
            {options}
          );
        }
        yield put(
          noCommonBenefits({
            message: memberNotFoundMessage,
            response: {},
          })
        );
        return;
      } else {
        datadogRum.addError(
          new Error(
            `Session API returned non-2xx status for AppID: ${appId} / Partner Code: ${partnerCode}.`
          ),
          undefined
        );
        yield put(commonBenefitsFailed());
        return;
      }
    } else {
      sessionId = existingSessionId;
      yield put(updateSessionId(sessionId));
    }
    while (retryBenefits && retryBenefitsCounter < 20) {
      completeResponse = yield call(
        fetchCommonBenefitsForUser,
        sessionId,
        sessionResponse.data?.appId ? sessionResponse.data?.appId : appId,
        sessionResponse.data?.partnerCode
          ? sessionResponse.data?.partnerCode
          : partnerCode
      );
      const commonUserBenefitsData = completeResponse.data;
      // Logs every poll attempt against fetchCommonBenefitsForUser (up to 20), so retries are visible in Datadog rather than only the final result.
      emitBenefitsJourneyEvent("benefits.search_attempted", {
        attempt: retryBenefitsCounter + 1,
        maxAttempts: 20,
        partnerCode,
        lookupType,
        status: completeResponse?.status,
        benefitStatus: commonUserBenefitsData?.status,
      });

      if (completeResponse.status === 200) {
        if (retryBenefitsCounter === 19) {
          retryBenefits = false;

          // Polling hit the 20-attempt ceiling without a definitive result.
          emitBenefitsJourneyEvent("benefits.not_found", {
            reason: "max_attempts_reached",
            attempts: 20,
            partnerCode,
            lookupType,
          });

          yield logAndReturnMaxAttemptsFailure(sessionId, !!experience?.allstatePartner);
        } else if (
          ACTIVE_MEMBERSHIP_STATUSES.includes(
            commonUserBenefitsData.status?.toUpperCase()
          ) ||
          commonUserBenefitsData.status?.toUpperCase() === "COMPLETED"
        ) {
          retryBenefits = false;

          // Polling resolved with an active/completed membership status.
          emitBenefitsJourneyEvent("benefits.found", {
            attempts: retryBenefitsCounter + 1,
            partnerCode,
            lookupType,
            benefitStatus: commonUserBenefitsData.status,
          });

          datadogRum.addAction(`Lookup Successful ${lookupType}`);
          promoCode = commonUserBenefitsData.promoCode;
          memberId = commonUserBenefitsData.memberId || "";
          postFix = commonUserBenefitsData.postFix
          if (existingSessionId && lookupType === "uuidLookup" && memberId) {
            const searchRescueResponse = yield call(
              searchRescue,
              partnerCode,
              appId,
              lookupType,
              memberId,
              postFix
            );
            if (searchRescueResponse.status === 200) {
              const { usageId = "", callId = "", duplicateRescueIronDoor = {} } =
                searchRescueResponse.data;
              experimentalMonitor(duplicateRescueIronDoor)(
                "Denominator",
                { usageId },
                "duplicateRescueIronDoor"
              );
              yield put(
                updateDuplicateRescueIsActive({
                  usageId,
                  callId,
                  duplicateRescueIronDoor,
                })
              );
              return;
            }
          }
          localStorage.setItem("memberId", memberId);
          authenticated = "Y";
          if (commonUserBenefitsData.vehicles?.[0]?.equipmentClass) {
            equpmnt_clss_id = commonUserBenefitsData.vehicles[0].equipmentClass;
          }

          yield* manageBenefitData({
            benefitsData: commonUserBenefitsData,
            partnerDetails,
            sessionId,
            type,
            phone,
          });

          logAndCheckAmcMilesFlow(commonUserBenefitsData);
        } else if (
          commonUserBenefitsData.status?.toUpperCase() === "CANCELLED"
        ) {
          datadogRum.addAction(`Lookup Successful ${lookupType}`);
          datadogRum.addAction(`Benefits Status Cancelled`);
          retryBenefits = false;

          // Membership was found but has been cancelled.
          emitBenefitsJourneyEvent("benefits.not_found", {
            reason: "cancelled",
            attempts: retryBenefitsCounter + 1,
            partnerCode,
            lookupType,
          });

          yield all([
            put(updatePpuFlag("Y")),
            put(
              noCommonBenefits({
                message: memberNotFoundMessage,
                response: {},
              })
            ),
          ]);
        } else if (
          commonUserBenefitsData.status?.toUpperCase() ===
          "MUST_CALL_FOR_WEIGHT_CLASS"
        ) {
          datadogRum.addAction(`Lookup Successful ${lookupType}`);
          datadogRum.addAction(`Benefits Status Must Call For Weight Class`);
          retryBenefits = false;

          // Member must call in because of an unsupported/unresolvable weight class.
          emitBenefitsJourneyEvent("benefits.not_found", {
            reason: "must_call_for_weight_class",
            attempts: retryBenefitsCounter + 1,
            partnerCode,
            lookupType,
          });

          yield put(
            noCommonBenefits({
              message: CONSTANTS.MUST_CALL_FOR_WEIGHT_CLASS,
              response: {},
            })
          );
        } else if (
          commonUserBenefitsData.status?.toUpperCase() === WAIT_PERIOD_STATUS
        ) {
          datadogRum.addAction(`Lookup Successful ${lookupType}`);
          datadogRum.addAction(`Benefits Status Wait Period`);
          retryBenefits = false;

          // Membership is currently within its waiting period, not yet active.
          emitBenefitsJourneyEvent("benefits.not_found", {
            reason: "wait_period",
            attempts: retryBenefitsCounter + 1,
            partnerCode,
            lookupType,
          });

          yield all([
            put(updatePpuFlag("Y")),
            put(
              noCommonBenefits({
                message: CONSTANTS.WAIT_PERIOD,
                response: {},
              })
            ),
          ]);
        } else if (
          (commonUserBenefitsData.experience?.serviceBased &&
            commonUserBenefitsData.status?.toUpperCase() ===
              CONSTANTS.INACTIVE) ||
          commonUserBenefitsData.status?.toUpperCase() ===
            CONSTANTS.NO_MEMBER_FOUND
        ) {
          retryBenefits = false;

          // Member is inactive or no matching member could be found.
          emitBenefitsJourneyEvent("benefits.not_found", {
            reason: "inactive_or_no_member_found",
            attempts: retryBenefitsCounter + 1,
            partnerCode,
            lookupType,
          });

          yield all([
            put(updateSessionId(completeResponse?.data?.callId)),
            put(updateUsageId(completeResponse?.data?.usageId)),
            put(
              updateServiceTransition({
                errorMessageContent: MEMBER_NOT_FOUND,
              })
            ),
            put(
              noCommonBenefits({
                message: memberNotFoundMessage,
                response: {},
              })
            ),
          ]);
        } else if (
          commonUserBenefitsData.status?.toUpperCase() ===
          CONSTANTS.MUTLIPLE_MEMBERS_FOUND
        ) {
          retryBenefits = false;

          // Lookup matched more than one member; cannot uniquely identify the caller.
          emitBenefitsJourneyEvent("benefits.not_found", {
            reason: "multiple_members_found",
            attempts: retryBenefitsCounter + 1,
            partnerCode,
            lookupType,
          });

          yield all([
            put(updateSessionId(completeResponse?.data?.callId)),
            put(updateUsageId(completeResponse?.data?.usageId)),
            put(
              updateServiceTransition({
                errorMessageContent: MEMBER_NOT_FOUND,
              })
            ),
            put(
              noCommonBenefits({
                message: CONSTANTS.MEMBER_NOT_UNIQUELY_FOUND_MESSAGE,
                response: {},
              })
            ),
          ]);
        }
      } else if (
        isCreatedNoContentStatus(completeResponse.status) ||
        is4xxClientError(completeResponse.status)
      ) {
        datadogRum.addAction(`Lookup Not Successful ${lookupType}`);
        let reasonFor4xx = completeResponse?.data?.message || "";
        datadogRum.addAction(`Lookup Not Successful Reason: ${reasonFor4xx}`);
        retryBenefits = false;

        // Benefits API returned a 4xx client error; treated as a terminal not-found.
        emitBenefitsJourneyEvent("benefits.not_found", {
          reason: "4xx_client_error",
          attempts: retryBenefitsCounter + 1,
          partnerCode,
          lookupType,
        });

        let errorMessage = memberNotFoundMessage;
        if (completeResponse?.data?.message === CONSTANTS.INVALID_MVA_NUMBER) {
          errorMessage = CONSTANTS.INVALID_MVA_NUMBER;
        }
        yield all([
          put(updatePpuFlag("Y")),
          put(
            noCommonBenefits({
              message: errorMessage,
              response: {},
            })
          ),
        ]);
      } else if (is5xxServerError(completeResponse.status)) {
        datadogRum.addAction(`Lookup Not Successful ${lookupType}`);
        let reasonFor5xx = completeResponse?.data || "";
        datadogRum.addAction(
          `Lookup Not Successful Reason: ${JSON.stringify(reasonFor5xx)}`
        );
        retryBenefits = false;

        // Benefits API returned a 5xx server error; treated as a terminal not-found.
        emitBenefitsJourneyEvent("benefits.not_found", {
          reason: "5xx_server_error",
          attempts: retryBenefitsCounter + 1,
          partnerCode,
          lookupType,
        });

        datadogRum.addError(
          new Error(
            `Benefits API returned status 500 for session ID ${sessionId}.`
          ),
          undefined
        );
        yield logAndReturn500Failure(sessionId);
      }

      retryBenefitsCounter++;
      yield delay(1000); // wait 1 second before retry logic
    }
  } catch (e) {
    if (is4xxClientError(e?.response?.status)) {
      const error = new Error(`Benefits API returned status 400 for session ID ${sessionId}.`);
      datadogRum.addError(error, { source: ErrorSource.NETWORK });
    } else {
      datadogRum.addError(new Error(`Benefits API returned status 500 for session ID ${sessionId}.`), {
        source: ErrorSource.NETWORK,
      });
    }
    yield put(commonBenefitsFailed(e));
  }
  if (route === "OmniAssist") {
    yield* logJacadaEvent({
      memberId,
      partnerCode,
      promoCode,
      sessionId,
      phone,
      authenticated,
      equpmnt_clss_id,
    });
  }
}

function* manageCommonData({benefitsData, omniStreamlined}) {
  if (!!omniStreamlined) {
    if (!!benefitsData?.memberId) {
      localStorage.setItem("memberId", benefitsData.memberId);
      yield put(updateMemberId(benefitsData.memberId));
    }

    if (!!benefitsData?.callId) {
      localStorage.setItem("benefitSession", benefitsData.callId);
      yield put(updateSessionId(benefitsData.callId));
    }

    if (!!benefitsData?.partnerMemberId) {
      yield put(updatePartnerMemberId(benefitsData.partnerMemberId));
    }

    if (!!benefitsData?.promoCode) {
      yield put(updatePromoCode(benefitsData.promoCode));
    }

    if (!!benefitsData?.usageId) {
      localStorage.setItem("usageId", benefitsData.usageId);
      yield put(updateUsageId(benefitsData.usageId));
    }

    if (!!benefitsData?.businessName) {
      yield put(updateBusinessName(benefitsData.businessName));
    }
    if (!!benefitsData?.rentalDetail) {
      yield put(updateRentalDetail(benefitsData.rentalDetail));
    }
    if (!!benefitsData?.stackedMembership) {
      yield put(updateStackedInfo(benefitsData.stackedMembership));
    }
    if (!!benefitsData?.postFix) {
      yield put(updatePostFix(benefitsData.postFix))
    }
  }
}

function* manageBenefitData({benefitsData, partnerDetails, sessionId, type, phone}) {
  const omniStreamlined = yield select(getOmniStreamlinedFlag)
  yield * manageCommonData({benefitsData, omniStreamlined});

  let { partnerCode, appId } = partnerDetails;

  if (partnerCode !== benefitsData.partnerCode) {
    partnerCode = benefitsData.partnerCode;
  }

  const outOfClaims = benefitsData.experience?.claimsExhausted;

  if (outOfClaims) {
    yield all([
      put(updatePpuFlag("Y")),
      put(updatePartnerDetailsExperience(benefitsData.experience)),
      logAndReturnOutOfClaims(benefitsData, omniStreamlined),
    ]);
  } else {
    yield all([
      put(updatePpuFlag("N")),
      put(updateLoggedInFlag("Y")),
      put(updatePartnerDetailsExperience(benefitsData.experience)),
      logAndReturnSuccess({
        sessionId,
        responseBody: benefitsData,
        partnerCode,
        appId,
        type,
        phone,
      }),
    ]);
  }
}

export function* benefits(action) {
  const commonBenefits = yield select(getCommonBenefits);
  const partnerDetails = yield select(getPartnerDetails);
  const serviceRequestPayload = yield select(getServiceRequestPayload);
  const serviceTransition = yield select(getServiceTransition);
  const omniStreamlined = yield select(getOmniStreamlinedFlag);
  let {
    partnerCode,
    route,
    appId,
    experience,
  } = partnerDetails;

  const memberNotFoundMessage = getMemberNotFoundMessage(!!experience?.allstatePartner);

  let postFix = serviceRequestPayload.postFix;
  const towTriageEnabled = experience?.towTriageEnabled;

  let details = action.payload.details;

  let vin = action.payload.vin || commonBenefits.vin;
  let primaryLookup =
    partnerDetails.experience?.lookupMethods?.components.primary;
  if (!vin) {
    vin = action.payload.formdata?.vin;
  }


  let phone = serviceRequestPayload.serviceRequest.contactNumber;
  let callId = serviceRequestPayload.sessionId;
  let usageId =
    localStorage.getItem("usageId") || serviceRequestPayload.usageId;

  let tollFreeNumber = localStorage.getItem("tollFreeNumber");
  let jobId = localStorage.getItem("jobId");
  let lastName = action.payload?.lastName || details?.lastName;
  let firstName = details?.firstName;

  let authenticated = "N";
  let completeResponse;
  let retryBenefits = true;
  let retryBenefitsCounter = 0;

  let partnerMemberId = action.payload.memberId || commonBenefits.memberId;
  let transactionNumber;

  let lookupType = action.payload.lookupType;
  if (lookupType === CONSTANTS.RENTAL_AGREEMENT_LOOKUP) {
    partnerMemberId = action.payload?.rentalAgreementNumber;
  } else if (lookupType === CONSTANTS.TRANSACTION_NUMBER_LOOKUP) {
    transactionNumber = action.payload?.transactionNumber;
  }
  let uuid = null;

  //enhancedAuth flow
  if(action?.payload?.enhancedAuthFlow) {
    const overrides = enhancedAuthLookupOverrides({
      partnerCode,
      partnerDetails,
      primaryLookup,
      partnerMemberId,
      lookupType,
      tollFreeNumber,
      payload: action.payload,
    });

    partnerMemberId = overrides.partnerMemberId;
    lookupType = overrides.lookupType;
    tollFreeNumber = overrides.tollFreeNumber;
    uuid = overrides.uuid
  }

  /**
   * B-2494463: Update lookup type for Consumer Cellular and Verizon
   * We want to change the lookup type to memberNumber, while keeping the lookup component as phone
   * The backend returns too many accounts when searching by phone, but just the associated account when searching by phone # as memberNumber
   */
  if ((partnerCode === VZW || partnerCode === C74) && (partnerMemberId || phone)) {
    lookupType = "memberNumber";
  }

  if (lookupType === MEMBER_NUMBER_VIN) {
    const userDetails = yield select(getUserDetails);
    details = userDetails;
  }

  try {
    const options = {
      partnerMemberId,
      transactionNumber,
      partnerCode,
      appId,
      details,
      phoneNumber: phone,
      tollFreeNumber,
      lookupType,
      jobId,
      vin,
      callId,
      usageId,
      guestFlow: action.payload.guestFlow,
      lastName,
      searchCallId: action.payload.searchCallId,
      uuid,
      customerType: action.payload.customerType
    };

    let { callId: tempCallId = "empty", searchCallId = "empty" } = options;
    if (tempCallId.includes("-") || searchCallId.includes("-")) {
      let tollFreeNumber = localStorage.getItem('tollFreeNumber');
      localStorage.clear();
      localStorage.setItem("tollFreeNumber", tollFreeNumber);

      let route = window.location.pathname.split("/")[1];
      let partner = window.location.pathname.split("/")[2];
      let url1;
      if(route === "benefits") {
        url1 = generatePathWithSearchParams(`/${route}/${partner}/memberlookup`);
      } else {
        url1 = generatePathWithSearchParams(`/${route}/${partner}/lookup`);
      }

      sessionStorage.setItem("invalid_session", "true");

      yield put(refreshReducersToInitial());
      yield call([action.history, action.history.push], url1);
      datadogRum.addAction("CommonBenefitsSaga - benefits - Recovered from SessionID as UUID.");
      return;
    }

    //TODO Add search Rescue check based off what??
    let memberId = action.payload.memberId || commonBenefits.memberId;
    let callbackNumber = phone;
    let membershipNumber = memberId;
    let vinNumber = vin;
    const denyListRequest = {
      firstName,
      lastName,
      callbackNumber,
      membershipNumber,
      vinNumber,
    };
    if (!isEmpty(denyListRequest) && JJ_AND_AMC.includes(partnerCode)) {
      denyListRequest.partnerCode = partnerCode;
      const denyResponse = yield call(fraudMonitor, {appId, denyRequest: denyListRequest});
      if (denyResponse?.success && denyResponse?.body?.statusText === "DENY") {
        yield put(
          commonBenefitsFailed({
            message: CONSTANTS.SERVICE_REQUEST_DENIED,
          })
        );
        yield put(
          updateServiceTransition({
            errorMessageContent: UNABLE_TO_PROCESS_REQUEST,
            declineType: CONSTANTS.SERVICE_REQUEST_DENIED,
          })
        );
      }
    }
    if (memberId) {
      const searchRescueResponse = yield call(
        searchRescue,
        partnerCode,
        appId,
        lookupType,
        memberId,
        postFix
      );
      if (searchRescueResponse.status === 200) {
        const { usageId = "", callId = "", duplicateRescueIronDoor = {} } =
          searchRescueResponse.data;
        experimentalMonitor(duplicateRescueIronDoor)(
          "Denominator",
          { usageId },
          "duplicateRescueIronDoor"
        );
        yield put(
          updateDuplicateRescueIsActive({
            usageId,
            callId,
            duplicateRescueIronDoor,
          })
        );
        return;
      }
    }

    if(action.payload.guestFlow){
      // Manual override for ppu/ghr flow
      if (partnerCode === "ghr") {
        appId = PPU_GHR_APP_ID;
        partnerCode = AMC
      }
      options.searchBy = "";
      options.lookupType = null;
      let promoCode = "";
      if (!isEmpty(action.payload.promoCode)) {
        promoCode = action.payload.promoCode;
      } else if (appId === PPU_GHR_APP_ID) {
        promoCode = GHR_HOLIDAY_PROMO_CODE;
      } else {
        promoCode = "010130030";
      }

      // B-2567882 Manually append state code for Puerto Rico
      const isPR = window.location.search.includes("PR");
      if (partnerCode === PEP && isPR) {
        options.details.stateCode = "PR";
      }

      // Single-shot PPU benefits lookup is about to be sent.
      emitBenefitsJourneyEvent("benefits.searched", {
        partnerCode,
        lookupType,
      });

      completeResponse = yield call(fetchPPUBenefits, options, appId, partnerCode, promoCode);
    } else {

      // Single-shot standard benefits lookup is about to be sent.
      emitBenefitsJourneyEvent("benefits.searched", {
        partnerCode,
        lookupType,
      });

      completeResponse = yield call(fetchBenefits, options, appId, partnerCode);
    }
    const benefitsData = completeResponse?.data;
    if (lookupType === LAST_NAME_STATE_ZIP && benefitsData.status === MUTLIPLE_MEMBERS_FOUND) {
      yield put(updateUserDetails(
        {firstName: details.firstName, lastName: details.lastName, stateCode: details.stateCode, zip: details.zip}));
    }

    const pepPromotionFlag = yield select(getPepPromotionFlag);
    if(pepPromotionFlag === CONSTANTS.ACTIVE) {
      benefitsData.status = "active";
    }

    //oneapp specific logic
    if (action.payload.searchCallId && benefitsData) {
      memberId = benefitsData.partnerMemberId;
      postFix = benefitsData.postFix;
      const searchRescueResponse = yield call(
        searchRescue,
        partnerCode,
        appId,
        "policyNumber",
        memberId,
        postFix
      );
      if (searchRescueResponse.status === 200) {
        const { usageId = "", callId = "", duplicateRescueIronDoor = {} } =
          searchRescueResponse.data;
        experimentalMonitor(duplicateRescueIronDoor)(
          "Denominator",
          { usageId },
          "duplicateRescueIronDoor"
        );
        yield put(
          updateDuplicateRescueIsActive({
            usageId,
            callId,
            duplicateRescueIronDoor,
          })
        );
        return;
      }
    }
    while (retryBenefits && retryBenefitsCounter < 3) {
      if (completeResponse?.status === 200) {
        retryBenefits = false;
        if (
          !!serviceTransition?.errorMessageContent ||
          !!serviceTransition?.declineType ||
          !!serviceTransition?.serviceType
        ) {
          yield put(
            updateServiceTransition({
              errorMessageContent: {},
              declineType: "",
              serviceType: "",
            })
          );
        }
        const benefitStatus = benefitsData?.status?.toUpperCase();

        // Single-shot lookup resolved; logs benefits.found for ACTIVE, otherwise benefits.not_found.
        emitBenefitsJourneyEvent(
          benefitStatus === "ACTIVE" ? "benefits.found" : "benefits.not_found",
          {
            callId: benefitsData.callId,
            usageId: benefitsData.usageId,
            benefitStatus: benefitStatus,
            partnerCode: benefitsData.partnerCode,
            lookupType: lookupType,
          }
        );

        datadogRum.addAction(
          `Benefits Status ${benefitStatus}`,
          {
            callId: benefitsData.callId,
            usageId: benefitsData.usageId,
            benefitStatus: benefitStatus,
            partnerCode: benefitsData.partnerCode,
            lookupType: lookupType,
          }
        );
        const serviceCost = benefitsData.experience?.serviceCost || {};
        yield put(updateServiceDetails(serviceCost));

        if (benefitsData?.tollFreeNumber) {
          localStorage.setItem("tollFreeNumber", benefitsData.tollFreeNumber);
        } else if (!localStorage.getItem("tollFreeNumber") && TOLL_FREE_NUMBER_PARTNERS.includes(benefitsData?.partnerCode)) {
          datadogRum.addAction(
            "Benefits Search did not return Toll Free Number from Job Id",
            { jobId, incomingNumber: phone, partnerCode: benefitsData.partnerCode }
          );
        }
        if (
          serviceRequestPayload?.promoCode == null ||
          benefitsData?.promoCode !== serviceRequestPayload.promoCode
        ) {
          yield put(updatePromoCode(benefitsData?.promoCode));
        }
        switch (benefitStatus) {
          case "GUEST":
            yield all([
              put(updatePpuFlag("Y")),
              put(updateSessionId(benefitsData?.callId)),
              put(updateUsageId(benefitsData?.usageId)),
              put(updatePartnerDetailsExperience(benefitsData?.experience)),
              put(
                noCommonBenefits({
                  message: "",
                  response: benefitsData,
                })
              ),
            ]);
            yield* manageCommonData({ benefitsData, omniStreamlined });
            return;
          case DISPATCH_GUARANTEE:
          case MEMBER_NOT_FOUND_VAS:
            yield all([
              put(
                updateServiceTransition({
                  errorMessageContent: MEMBER_NOT_FOUND,
                })
              ),
              put(
                noCommonBenefits({
                  message: CONSTANTS.MEMBER_NOT_UNIQUELY_FOUND_MESSAGE,
                  response: {},
                })
              ),
            ]);
            return;
          case MUTLIPLE_MEMBERS_FOUND:
            yield all([
              put(updateSessionId(completeResponse?.data?.callId)),
              put(updateUsageId(completeResponse?.data?.usageId)),
              put(
                updateServiceTransition({
                  errorMessageContent: MEMBER_NOT_FOUND,
                })
              ),
              put(
                noCommonBenefits({
                  message: CONSTANTS.MEMBER_NOT_UNIQUELY_FOUND_MESSAGE,
                  response: {},
                })
              ),
            ]);
            return;
          case MULTIPLE_MEMBERS_RETURNED:
            yield all([
              put(updateSessionId(benefitsData?.callId)),
              put(updateUsageId(benefitsData?.usageId)),
              put(
                updateServiceTransition({
                  errorMessageContent: MEMBER_NOT_FOUND,
                })
              ),
              put(
                noCommonBenefits({
                  message: memberNotFoundMessage,
                  response: {},
                })
              ),
            ]);
            return;
          case MATCH_FAILURE:
            logPolicyDrivenPpuEligibility("benefits_not_found", {
              benefitsStatus: benefitsData?.status,
              partnerCode,
              callId: benefitsData?.callId,
            });
            yield all([
              put(updateSessionId(benefitsData?.callId)),
              put(updateUsageId(benefitsData?.usageId)),
              put(updatePpuFlag("Y")),
              put(
                updateServiceTransition({
                  errorMessageContent: MEMBER_NOT_FOUND,
                })
              ),
              put(
                noCommonBenefits({
                  message: memberNotFoundMessage,
                  response: benefitsData,
                })
              ),
            ]);
            return;
          case CONTRACT_CANCELLED:
            if(benefitsData.experience?.serviceBased){
              yield all([
                put(
                  updateServiceTransition({
                    errorMessageContent: MEMBER_NOT_FOUND,
                  })
                ),
                put(
                  noCommonBenefits({
                    message: CONSTANTS.MEMBER_NOT_FOUND_MESSAGE,
                    response: {},
                  })
                ),
              ]);
              return;
            }
            logPolicyDrivenPpuEligibility("benefits_cancelled", {
              benefitsStatus: benefitsData?.status,
              partnerCode,
              callId: benefitsData?.callId,
            });
            // falls through
          case CONTRACT_EXPIRED:
          case CONTRACT_NOT_ACTIVE_YET:
          case INACTIVE:
          case BENEFITS_USED_UP:
          case REIMBURSEMENT:
            if (benefitStatus === CONTRACT_EXPIRED) {
              logPolicyDrivenPpuEligibility("benefits_expired", {
                benefitsStatus: benefitsData?.status,
                partnerCode,
                callId: benefitsData?.callId,
              });
            } else if (benefitStatus === BENEFITS_USED_UP) {
              logPolicyDrivenPpuEligibility("benefits_used_up", {
                benefitsStatus: benefitsData?.status,
                partnerCode,
                callId: benefitsData?.callId,
              });
            }
            yield* manageCommonData({ benefitsData, omniStreamlined });
            yield all([
              put(updatePpuFlag("Y")),
              put(updatePartnerDetailsExperience(benefitsData.experience)),
              put(updatePromoCode(benefitsData?.ppuPromoCode)),
              logAndReturnOutOfClaims(benefitsData, omniStreamlined)
            ]);
            break;
          case MEMBER_NOT_FOUND_STATUS:
            let errorMessage = memberNotFoundMessage;
            if (
              lookupType === CONSTANTS.MOTOR_NUMBER_LOOKUP ||
              lookupType === CONSTANTS.RENTAL_AGREEMENT_LOOKUP
            ) {
              errorMessage = CONSTANTS.INVALID_MVA_NUMBER;
            }
            yield* manageCommonData({ benefitsData, omniStreamlined });
            if (benefitsData?.experience) {
              yield put(
                updatePartnerDetailsExperience(benefitsData.experience)
              );
            }
            yield all([
              put(updatePpuFlag("Y")),
              put(
                noCommonBenefits({
                  message: errorMessage,
                  response: benefitsData,
                })
              ),
            ]);
            break;
          case WAIT_PERIOD_STATUS:
            yield* manageCommonData({ benefitsData, omniStreamlined });
            if (benefitsData?.experience) {
              yield put(
                updatePartnerDetailsExperience(benefitsData.experience)
              );
            }
            yield all([
              put(updatePpuFlag("Y")),
              put(
                noCommonBenefits({
                  message: CONSTANTS.WAIT_PERIOD,
                  response: benefitsData,
                })
              ),
            ]);
            break;
          case CONSTANTS.ACTIVE:
          case CONSTANTS.MUST_DISPLAY_TRIAGE_STEPS:
          case CONSTANTS.MUST_SHOW_NO_BENEFITS_PRICING_INFO:
            authenticated = "Y";
            yield* manageBenefitData({
              benefitsData: benefitsData,
              partnerDetails,
              sessionId: benefitsData.callId,
              type: "omni-client",
              phone,
            });
            break;
          case CONSTANTS.MUST_CALL_FOR_WEIGHT_CLASS:
            yield all([
              put(updatePartnerDetailsExperience(benefitsData.experience)),
              put(
                updateServiceTransition({
                  declineType: CONSTANTS.MUST_CALL_FOR_WEIGHT_CLASS,
                })
              ),
              put(
                noCommonBenefits({
                  message: CONSTANTS.MUST_CALL_FOR_WEIGHT_CLASS,
                  response: benefitsData,
                })
              ),
            ]);
            break;
          default:
            yield all([
              put(
                updateServiceTransition({
                  errorMessageContent: MEMBER_NOT_FOUND,
                })
              ),
              put(
                noCommonBenefits({
                  message: memberNotFoundMessage,
                  response: {},
                })
              ),
            ]);
            return;
        }

        if (route === "OmniAssist") {
          yield* logJacadaEvent({
            memberId: partnerMemberId,
            partnerCode,
            promoCode: benefitsData.promoCode,
            sessionId: benefitsData.callId,
            phone,
            authenticated,
            equpmnt_clss_id: "",
          });
        }
        return;
      } else if (
        isCreatedNoContentStatus(completeResponse?.status) ||
        is4xxClientError(completeResponse?.status)
      ) {
        datadogRum.addAction(
          `Omni Search Lookup Not Successful for ${lookupType} reason ${completeResponse?.data?.message}`
        );
        yield all([
          put(
            noCommonBenefits({
              message: memberNotFoundMessage,
              response: {},
            })
          ),
        ]);
        retryBenefits = false;
        return;
      } else if (is5xxServerError(completeResponse?.status)) {
        datadogRum.addAction(
          `500 Omni Search Lookup Not Successful for ${lookupType} reason ${completeResponse?.data}`
        );
        yield put({ type: COMMON_BENEFITS_FAILED });
        retryBenefits = false;
        return;
      }
      retryBenefitsCounter++;
      yield delay(1000); // wait 1 second before retry logic
    }
    // if its still not successful then send commonBenefitsFailed
    if(retryBenefits && retryBenefitsCounter > 2)
      yield put(commonBenefitsFailed());
  } catch (e) {
    if (is4xxClientError(e?.response?.status) || is5xxServerError(e?.response?.status)) {
      datadogRum.addError(`Omni Search API returned status ${e?.response?.status}`);

    } else {
      datadogRum.addError(`Omni Search API returned an error`, {e})
    }
    yield put(commonBenefitsFailed());
  }
}

export function* watchCommonBenefitsSaga() {
  yield takeEvery(COMMON_BENEFITS_START, commonBenefits);
}

export function* watchBenefitLookupSaga() {
  yield takeEvery(BENEFITS_LOOKUP_START, benefits);
}
